<div fxLayout="column" class="option-wrap">
  <div class="option-title">
    <img *ngIf="option.iconUrl" [src]="option.iconUrl">
    <mat-icon *ngIf="!option.iconUrl" aria-hidden="false" aria-label="Example home icon" style=" vertical-align: middle;">{{ option && option.icon ? option.icon : 'adjust' }}</mat-icon>
    <span style="margin-left: 7px; vertical-align: middle;">{{option.title}}</span></div>
  <div class="option-description" fxFlex="">{{option.description}}</div>
  <div fxFlex="0 0 auto">
    <ng-container *ngIf="option.options_type === 'multiple_choice'">
      <mat-form-field fxFlex="100%" appearance="outline" style="margin-bottom: -2.25em">
<!--        <mat-label>{{option.title}}</mat-label>-->
        <mat-select [required]="hasRequiredField(control)" [formControl]="control" id="carrier_{{option.uid}}">
          <ng-container *ngFor="let selectorOption of option.options">
            <mat-option [value]="selectorOption.value">
              <ng-container *ngIf="!selectorOption.value && selectorOption.value !== 0">
                N/A
              </ng-container>
              <ng-container *ngIf="selectorOption['data_type'] === 'currency'">
                {{selectorOption.value | stripeCurrency}}
              </ng-container>
              <ng-container *ngIf="selectorOption['data_type'] === 'percent'">
                {{selectorOption.value}}%
              </ng-container>
              <ng-container *ngIf="selectorOption['data_type'] !== 'currency' && selectorOption['data_type'] !== 'percent' && selectorOption['data_type'] !== 'none'">
                {{selectorOption.value}}
              </ng-container>
            </mat-option>
          </ng-container>

          <mat-error *ngIf="control.errors" class="invalid-input-dedactible">
            {{ control.controls[option.uid] | errorMsg }}
          </mat-error>
        </mat-select>
<!--        <app-form-descriptor matSuffix [message]="option.description" *ngIf="option.description"></app-form-descriptor>-->
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="option.options_type !== 'multiple_choice'">
      <div class="coverage-checkbox" style="margin-top:-10px; margin-bottom: -2.25em">
        <mat-checkbox id="carrier_{{option.uid}}" [formControl]="control" [disabled]="option.requirement === 'required'">{{option.title}}</mat-checkbox>
<!--        <app-form-descriptor matSuffix [message]="option.description" *ngIf="option.description"></app-form-descriptor>-->
      </div>
    </ng-container>
  </div>
</div>

